import { InjectionToken, StaticProvider } from "@angular/core";
import { openFacetEvent } from "./events";
import { Event } from '../types';

export interface Events {
  openFacet: Event<{ elementId: string, componentId: string }>;
}

const Api: Events = {
  openFacet: openFacetEvent,
};

export const EVENTS_TOKEN = new InjectionToken<Events>('EVENTS_TOKEN');
export const EVENTS_PROVIDER: StaticProvider = {
  provide: EVENTS_TOKEN,
  useValue: Api,
};

window.mfStore ??= {};
window.mfStore.events = Api;